export default function hasOfferPriceChanged(offer: any) {
    return !(offer.initialOfferPrice === offer.offerPrice);
}
